// https://www.figma.com/file/NRd2J4ezQVsJqaOoU256v5Cg/Gaia-GPS-Colors?node-id=66%3A0
export const CONIFER_1 = '#184023';
export const CONIFER_2 = '#1C4F2B';
export const CONIFER_3 = '#276338';
export const CONIFER_4 = '#2F7944';
export const CONIFER_5 = '#36854D';
export const CONIFER_6 = '#409D5B';
export const CONIFER_7 = '#69C083';
export const CONIFER_8 = '#A1DAB3';
export const CONIFER_9 = '#C7EBD3';
export const CONIFER_10 = '#E0F5E7';
export const CONIFER = CONIFER_3;

export const SPRING_1 = '#1A4E18';
export const SPRING_2 = '#1C631A';
export const SPRING_3 = '#268623';
export const SPRING_4 = '#2F9B2C';
export const SPRING_5 = '#38B234';
export const SPRING_6 = '#3CC537';
export const SPRING_7 = '#4CD948';
export const SPRING_8 = '#85EB81';
export const SPRING_9 = '#BEF7BC';
export const SPRING_10 = '#E9FCE8';
export const SPRING = SPRING_4;

export const SUMMER_1 = '#872712';
export const SUMMER_2 = '#A32F15';
export const SUMMER_3 = '#B8381C';
export const SUMMER_4 = '#CF4425';
export const SUMMER_5 = '#E35030';
export const SUMMER_6 = '#EA674B';
export const SUMMER_7 = '#F18D78';
export const SUMMER_8 = '#F8B5AA';
export const SUMMER_9 = '#FFD9D4';
export const SUMMER_10 = '#FFF0EE';
export const SUMMER = SUMMER_4;

export const FALL_1 = '#D4500F';
export const FALL_2 = '#E06214';
export const FALL_3 = '#ED7011';
export const FALL_4 = '#F58311';
export const FALL_5 = '#FA921B';
export const FALL_6 = '#FCA338';
export const FALL_7 = '#FCB156';
export const FALL_8 = '#FDCD93';
export const FALL_9 = '#FFE8C4';
export const FALL_10 = '#FFF7EB';
export const FALL = FALL_4;

export const WINTER_1 = '#07596E';
export const WINTER_2 = '#0A708A';
export const WINTER_3 = '#0C86A5';
export const WINTER_4 = '#1399BA';
export const WINTER_5 = '#24A8C9';
export const WINTER_6 = '#36B8D9';
export const WINTER_7 = '#67D0EB';
export const WINTER_8 = '#8FE2F7';
export const WINTER_9 = '#C4F3FF';
export const WINTER_10 = '#E5FAFF';
export const WINTER = WINTER_2;

export const GRANITE_1 = '#1C1D1F';
export const GRANITE_2 = '#38383B';
export const GRANITE_3 = '#606163';
export const GRANITE_4 = '#7B7B7D';
export const GRANITE_5 = '#939496';
export const GRANITE_6 = '#ACACAE';
export const GRANITE_7 = '#CFD1D3';
export const GRANITE_8 = '#E3E3E5';
export const GRANITE_9 = '#F1F2F3';
export const GRANITE_10 = '#FFFFFF';

export const SNOW_BLIND = GRANITE_10;

export const OUTSIDE_YELLOW_2 = '#D2A940';
export const OUTSIDE_YELLOW_1 = '#FDFBEE';
export const OUTSIDE_YELLOW = '#ffd200';

export const GaiaColors: Record<GaiaColorName, GaiaColorHex> = {
    Red: '#F42410',
    Pink: '#E834EC',
    Purple: '#A726BC',
    'Dark Purple': '#5726C2',
    'Dark Blue': '#2D3FC7',
    Blue: '#0479FF',
    'Light Blue': '#00B2FF',
    Aqua: '#00DAE1',
    Teal: '#00A478',
    Green: '#4ABD32',
    Lime: '#7AD915',
    'Yellow-Green': '#BAF200',
    Yellow: '#FFEF00',
    'Yellow-Orange': '#FFC900',
    Orange: '#FF9D00',
    'Dark Orange': '#FF6200',
    Brown: '#784D3E',
    Grey: '#A4A4A4',
    'Blue-Grey': '#5E7A8C',
    Black: '#000000',
    White: '#FFFFFF',
};

export const GaiaColorNames: GaiaColorName[] = Object.keys(GaiaColors) as GaiaColorName[];

export const GaiaColorHexes: GaiaColorHex[] = Object.values(GaiaColors) as GaiaColorHex[];

export const GaiaRed = GaiaColors['Red'];
